import React from 'react'
import { Card, Badge, Row, Col, Alert } from 'react-bootstrap'
import { AppleIdConfig } from 'interfaces/pns-phone-number'

interface AppleIdConfigCardProps {
  appleIdConfig?: AppleIdConfig
  phoneNumber?: string
}

const AppleIdConfigCard: React.FC<AppleIdConfigCardProps> = ({
  appleIdConfig,
  phoneNumber,
}) => {
  if (!appleIdConfig) {
    return (
      <Card className="mb-4">
        <Card.Header>
          <h4>Apple ID</h4>
        </Card.Header>
        <Card.Body>
          <Alert variant="secondary">No Apple ID found for this device.</Alert>
        </Card.Body>
      </Card>
    )
  }

  return (
    <Card className="mb-4">
      <Card.Header>
        <h4>Apple ID</h4>
      </Card.Header>
      <Card.Body>
        {phoneNumber && (
          <Alert variant="info" className="mb-4">
            <strong>Phone Number:</strong> {phoneNumber}
          </Alert>
        )}

        {/* Basic Info */}
        <div className="mb-4">
          <h6 className="text-muted mb-3">Account Information</h6>
          <Row>
            <Col md={6}>
              <p>
                <strong>Apple ID Email:</strong>{' '}
                {appleIdConfig.appleIdEmail || 'N/A'}
              </p>
            </Col>
          </Row>
        </div>

        {/* Services */}
        <div className="mb-4">
          <h6 className="text-muted mb-3">Services</h6>
          <Row>
            <Col md={6}>
              <p>
                <strong>iMessage:</strong>{' '}
                {appleIdConfig.iMessageEnabled ? (
                  <Badge variant="success">Enabled</Badge>
                ) : (
                  <Badge variant="secondary">Disabled</Badge>
                )}
              </p>
            </Col>
            <Col md={6}>
              <p>
                <strong>FaceTime:</strong>{' '}
                {appleIdConfig.facetimeEnabled ? (
                  <Badge variant="success">Enabled</Badge>
                ) : (
                  <Badge variant="secondary">Disabled</Badge>
                )}
              </p>
            </Col>
          </Row>
        </div>

        {/* Forwarding Settings */}
        <div className="mb-4">
          <h6 className="text-muted mb-3">Forwarding Settings</h6>
          <Row>
            <Col md={6}>
              <p>
                <strong>Forwarding Number:</strong>{' '}
                {appleIdConfig.forwardingNumber || 'Not set'}
              </p>
              <p>
                <strong>SMS Forwarding:</strong>{' '}
                {appleIdConfig.smsForwardingEnabled ? (
                  <Badge variant="success">Enabled</Badge>
                ) : (
                  <Badge variant="secondary">Disabled</Badge>
                )}
              </p>
            </Col>
            <Col md={6}>
              <p>
                <strong>Call Forwarding:</strong>{' '}
                {appleIdConfig.callForwardingEnabled ? (
                  <Badge variant="success">Enabled</Badge>
                ) : (
                  <Badge variant="secondary">Disabled</Badge>
                )}
              </p>
            </Col>
          </Row>
        </div>

        {/* Reflector Settings */}
        {appleIdConfig.isReflector && (
          <div className="mb-4">
            <h6 className="text-muted mb-3">Reflector Settings</h6>
            <Row>
              <Col md={6}>
                <p>
                  <strong>Is Reflector:</strong>{' '}
                  <Badge variant="info">Yes</Badge>
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>Reflector Endpoint:</strong>{' '}
                  {appleIdConfig.reflectorEndpoint || 'Not set'}
                </p>
              </Col>
            </Row>
          </div>
        )}

        {/* Metadata */}
        <div className="mb-2">
          <h6 className="text-muted mb-3">Metadata</h6>
          <Row>
            <Col md={6}>
              <p>
                <strong>Last Sync:</strong>{' '}
                {appleIdConfig.lastSyncAt
                  ? new Date(appleIdConfig.lastSyncAt).toLocaleString()
                  : 'Never'}
              </p>
            </Col>
            <Col md={6}>
              <p>
                <strong>Created:</strong>{' '}
                {new Date(appleIdConfig.createdAt).toLocaleString()}
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <p>
                <strong>Updated:</strong>{' '}
                {new Date(appleIdConfig.updatedAt).toLocaleString()}
              </p>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  )
}

export default AppleIdConfigCard
